import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0f93f836")

_pushScopeId("data-v-0f93f836")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = {
  key: 0,
  class: "p-col-4"
}
const _hoisted_3 = { class: "p-d-flex p-jc-between" }
const _hoisted_4 = { class: "p-input-icon-left" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = { class: "p-text-nowrap p-text-truncate" }
const _hoisted_7 = { style: {"height":"2vh"} }
const _hoisted_8 = { class: "p-text-nowrap p-text-truncate" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "p-text-nowrap p-text-truncate"
}
const _hoisted_11 = {
  key: 0,
  class: "p-d-flex p-jc-center p-ai-center"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.editable)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_DataTable, {
            value: _ctx.allUsers,
            responsiveLayout: "scroll",
            selectionMode: "multiple",
            metaKeySelection: false,
            selection: _ctx.selectedUsers,
            "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedUsers = $event)),
            filters: _ctx.filters,
            "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
            class: "list-users",
            onRowSelect: _ctx.onRowSelect,
            onRowUnselect: _ctx.onRowUnselect,
            onRowSelectAll: _ctx.onSelectAll,
            onRowUnselectAll: _ctx.onUnselectAll
          }, {
            header: _withId(() => [
              _createVNode("div", _hoisted_3, [
                _createVNode("span", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.filters['global'].value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                    placeholder: _ctx.$t('workspace.edit.popup.member.search')
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ])
            ]),
            empty: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("automl.create.not.found")), 1)
            ]),
            default: _withId(() => [
              _createVNode(_component_Column, {
                selectionMode: "multiple",
                style: {"width":"3rem"}
              }),
              _createVNode(_component_Column, {
                field: "id",
                header: _ctx.$t('workspace.edit.popup.member.title')
              }, {
                body: _withId((slotProps) => [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("span", null, _toDisplayString(_ctx.getFullname(slotProps.data.id)), 1)
                  ])
                ]),
                _: 1
              }, 8, ["header"])
            ]),
            _: 1
          }, 8, ["value", "selection", "filters", "onRowSelect", "onRowUnselect", "onRowSelectAll", "onRowUnselectAll"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: _ctx.editable ? 'p-col-8' : 'p-col-12'
    }, [
      _createVNode("div", _hoisted_7, _toDisplayString(_ctx.editable
            ? _ctx.$t("workspace.members.select", {
                members: _ctx.newMembers.length,
              })
            : _ctx.$t("workspace.members", {
                members: _ctx.newMembers.length,
              })), 1),
      _createVNode(_component_DataTable, {
        value: _ctx.newMembers,
        scrollHeight: "flex",
        class: "list-members"
      }, {
        footer: _withId(() => [
          (_ctx.workspaces && _ctx.workspaces.length === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString(_ctx.$t("experiment.list-experiment.table.empty")), 1))
            : _createCommentVNode("", true)
        ]),
        default: _withId(() => [
          _createVNode(_component_Column, {
            field: "userId",
            header: _ctx.$t('workspace.member.list.header.user.name')
          }, {
            body: _withId((slotProps) => [
              _createVNode("div", _hoisted_8, [
                _createVNode("span", null, _toDisplayString(_ctx.getUsername(slotProps.data.userId)), 1)
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "userId",
            header: _ctx.$t('workspace.member.list.header.full.name'),
            headerClass: "name-column",
            bodyClass: "name-column"
          }, {
            body: _withId((slotProps) => [
              _createVNode("div", null, _toDisplayString(_ctx.getFullname(slotProps.data.userId)), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "role",
            header: _ctx.$t('workspace.member.list.header.role')
          }, {
            body: _withId((slotProps) => [
              (
                (_ctx.editable &&
                  slotProps.data.userId !== _ctx.workspaceDetail?.ownerId &&
                  _ctx.mode !== 'create') ||
                (_ctx.mode === 'create' && slotProps.data.userId !== _ctx.userId)
              )
                ? (_openBlock(), _createBlock(_component_Dropdown, {
                    key: 0,
                    modelValue: _ctx.selectedRole[slotProps.data.userId],
                    "onUpdate:modelValue": ($event: any) => (_ctx.selectedRole[slotProps.data.userId] = $event),
                    options: _ctx.workspaceRoleList,
                    onChange: ($event: any) => (_ctx.onChangeRole($event, slotProps.data.userId)),
                    style: {"width":"110px"}
                  }, {
                    value: _withId((roles) => [
                      (roles.value)
                        ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(_ctx.$t(`workspace.role.${roles.value}`)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    option: _withId((roles) => [
                      _createTextVNode(_toDisplayString(_ctx.$t(`workspace.role.${roles.option}`)), 1)
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "options", "onChange"]))
                : (_openBlock(), _createBlock("div", _hoisted_10, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t(`workspace.role.${_ctx.selectedRole[slotProps.data.userId]}`)), 1)
                  ]))
            ]),
            _: 1
          }, 8, ["header"]),
          (_ctx.editable)
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 0,
                header: _ctx.$t('action'),
                class: "action-column"
              }, {
                body: _withId((slotProps) => [
                  (slotProps.data.userId !== _ctx.workspaceDetail?.ownerId)
                    ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "p-button-rounded p-button-secondary p-button-text",
                        icon: "pi pi-trash",
                        onClick: ($event: any) => (_ctx.removeMember($event, slotProps.data))
                      }, null, 8, ["onClick"])), [
                        [
                          _directive_tooltip,
                          _ctx.$t('button.delete'),
                          void 0,
                          { top: true }
                        ]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["header"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value"])
    ], 2)
  ]))
})